(() => {
  'use strict';
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  window.BeerClubShippingView = {
    render(widget, rates, currency) {
      const output = widget.querySelector('[data-shipping-results]');
      const benefit = widget.closest('.shipping-box').querySelector('[data-shipping-benefit]');
      const summary = widget.querySelector('[data-shipping-summary]');
      const drawer = widget.closest('#CartDrawer');
      const money = value => window.BeerClubCommerce.rateMoney(value, currency);
      const valid = rate => rate.price !== null && rate.price !== '' && Number.isFinite(Number(rate.price)) && Number(rate.price) >= 0;
      const discounted = rate => rate.subsidyBps > 0 && rate.fullPrice > Number(rate.price);
      const delivery = rate => {
        if (!Array.isArray(rate.delivery_days) || !rate.delivery_days.length || !rate.delivery_days.every(day => Number.isInteger(day) && day >= 0)) return '';
        const min = Math.min(...rate.delivery_days), max = Math.max(...rate.delivery_days);
        return (min === max ? min : min + '–' + max) + (rate.businessDays ? max === 1 ? ' dia útil' : ' dias úteis' : max === 1 ? ' dia' : ' dias');
      };
      const prices = rate => {
        const node = element('span', undefined, 'shipping-prices');
        if (discounted(rate)) node.append(element('s', money(rate.fullPrice)));
        node.append(element('strong', valid(rate) && Number(rate.price) === 0 ? 'Grátis' : money(rate.price)));
        return node;
      };
      if (widget.hasAttribute('data-shipping-product')) {
        const rate = rates[0];
        const row = element('div', undefined, 'shipping-quote');
        const description = element('span', undefined, 'shipping-description');
        description.append(element('strong', rate.presentment_name || rate.name || 'Entrega'));
        if (Array.isArray(rate.delivery_days) && rate.delivery_days.length && rate.delivery_days.every(day => Number.isInteger(day) && day >= 0)) {
          const min = Math.min(...rate.delivery_days), max = Math.max(...rate.delivery_days);
          description.append(element('small', (min === max ? min : min + '–' + max) + (max === 1 ? ' dia útil' : ' dias úteis')));
        }
        if (discounted(rate)) description.append(element('small', rate.subsidyBps === 10000 ? 'Frete grátis' : rate.subsidyBps / 100 + '% de desconto', 'shipping-discount-badge'));
        row.append(description, prices(rate));
        output.replaceChildren(row);
        benefit.replaceChildren(); benefit.hidden = true;
        return;
      }
      const select = rate => {
        summary?.replaceChildren(prices(rate));
        if (summary && delivery(rate)) summary.append(element('small', delivery(rate), 'shipping-delivery-days'));
        benefit.replaceChildren(); benefit.hidden = false;
        if (discounted(rate) && (!drawer || drawer.dataset.progressEnabled !== 'false')) {
          const tiers = element('div', undefined, 'shipping-tiers');
          tiers.setAttribute('role', 'group');
          tiers.setAttribute('role', 'group');
          tiers.setAttribute('aria-label', 'Desconto no frete: ' + rate.subsidyBps / 100 + '%');
          [[2500, '25% off'], [5000, '50% off'], [10000, 'Grátis']].forEach(([bps, label]) => {
            const step = element('span', label, rate.subsidyBps >= bps ? 'is-earned' : '');
            step.setAttribute('aria-hidden', 'true'); tiers.append(step);
          });
          benefit.append(tiers);
          const savings = element('div', undefined, 'shipping-savings');
          savings.append(element('span', 'Você economizou no frete'), element('strong', money(rate.fullPrice - Number(rate.price))));
          benefit.append(savings);
        }
        if (!drawer && valid(rate) && Number.isFinite(rate.cartTotal)) {
          const total = element('div', undefined, 'shipping-estimated-total');
          total.append(element('span', 'Total com frete estimado'), element('strong', money(rate.cartTotal + Number(rate.price))));
          benefit.append(total);
        }
        if (!benefit.childElementCount) benefit.hidden = true;
        widget.dispatchEvent(new CustomEvent('beerclub:shipping-selected', { bubbles: true, detail: { rate, currency } }));
      };
      output.replaceChildren();
      if (drawer) {
        const label = element('label', 'Entrega estimada', 'shipping-rate-label');
        const choices = element('select', undefined, 'shipping-rate-select');
        choices.setAttribute('data-shipping-rate-select', '');
        rates.forEach((rate, index) => {
          const option = element('option'); option.value = String(index);
          const days = delivery(rate) ? ' · ' + delivery(rate) : '';
          option.textContent = (rate.presentment_name || rate.name || 'Entrega') + ' · ' + (valid(rate) && Number(rate.price) === 0 ? 'Grátis' : money(rate.price)) + days;
          choices.append(option);
        });
        choices.addEventListener('change', () => select(rates[Number(choices.value)]));
        label.append(choices); output.append(label); select(rates[0]);
        return;
      }
      const group = element('fieldset', undefined, 'shipping-options');
      group.append(element('legend', 'Escolha a entrega estimada', 'visually-hidden'));
      rates.forEach((rate, index) => {
        const row = element('label', undefined, 'shipping-option');
        const radio = element('input'); radio.type = 'radio'; radio.name = 'shipping-rate-' + widget.querySelector('[data-shipping-zip]').id; radio.checked = index === 0;
        radio.addEventListener('change', () => { if (radio.checked) select(rate); });
        const description = element('span', undefined, 'shipping-description');
        description.append(element('strong', rate.presentment_name || rate.name || 'Entrega'));
        if (Array.isArray(rate.delivery_days) && rate.delivery_days.length && rate.delivery_days.every(day => Number.isInteger(day) && day >= 0)) {
          const min = Math.min(...rate.delivery_days), max = Math.max(...rate.delivery_days);
          description.append(element('small', (min === max ? min : min + '–' + max) + (rate.businessDays ? ' dias úteis' : ' dia(s)')));
        }
        if (discounted(rate)) description.append(element('small', rate.subsidyBps === 10000 ? 'Frete grátis' : rate.subsidyBps / 100 + '% de desconto', 'shipping-discount-badge'));
        row.append(radio, description, prices(rate)); group.append(row);
      });
      output.append(group); select(rates[0]);
    }
  };
})();
